import _toConsumableArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import assemblyManagerFactory, { assemblyConfigSchemaFactory } from '@jbrowse/core/assemblyManager';
import PluginManager from '@jbrowse/core/PluginManager';
import RpcManager from '@jbrowse/core/rpc/RpcManager';
import TextSearchManager from '@jbrowse/core/TextSearch/TextSearchManager';
import { cast, getSnapshot, types } from 'mobx-state-tree';
import corePlugins from '../corePlugins';
import createConfigModel from './createConfigModel';
import createSessionModel from './createSessionModel';
export default function createModel(runtimePlugins) {
  var makeWorkerInstance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    throw new Error('no makeWorkerInstance supplied');
  };
  var pluginManager = new PluginManager([].concat(_toConsumableArray(corePlugins), _toConsumableArray(runtimePlugins)).map(function (P) {
    return new P();
  }));
  pluginManager.createPluggableElements();
  var Session = createSessionModel(pluginManager);
  var assemblyConfig = assemblyConfigSchemaFactory(pluginManager);
  var AssemblyManager = assemblyManagerFactory(assemblyConfig, pluginManager);
  var rootModel = types.model('ReactLinearGenomeView', {
    config: createConfigModel(pluginManager, assemblyConfig),
    session: Session,
    assemblyManager: types.optional(AssemblyManager, {}),
    disableAddTracks: types.optional(types.boolean, false),
    internetAccounts: types.array(pluginManager.pluggableMstType('internet account', 'stateModel'))
  }).volatile(function (self) {
    return {
      error: undefined,
      rpcManager: new RpcManager(pluginManager, self.config.configuration.rpc, {
        WebWorkerRpcDriver: {
          makeWorkerInstance: makeWorkerInstance
        },
        MainThreadRpcDriver: {}
      }),
      textSearchManager: new TextSearchManager(pluginManager)
    };
  }).actions(function (self) {
    return {
      setSession: function setSession(sessionSnapshot) {
        self.session = cast(sessionSnapshot);
      },
      renameCurrentSession: function renameCurrentSession(sessionName) {
        if (self.session) {
          var snapshot = JSON.parse(JSON.stringify(getSnapshot(self.session)));
          snapshot.name = sessionName;
          this.setSession(snapshot);
        }
      },
      setError: function setError(errorMessage) {
        self.error = errorMessage;
      },
      addInternetAccount: function addInternetAccount(internetAccount) {
        self.internetAccounts.push(internetAccount);
      },
      findAppropriateInternetAccount: function findAppropriateInternetAccount(location) {
        // find the existing account selected from menu
        var selectedId = location.internetAccountId;
        if (selectedId) {
          var selectedAccount = self.internetAccounts.find(function (account) {
            return account.internetAccountId === selectedId;
          });
          if (selectedAccount) {
            return selectedAccount;
          }
        }
        // if no existing account or not found, try to find working account
        var _iterator = _createForOfIteratorHelper(self.internetAccounts),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var account = _step.value;
            var handleResult = account.handlesLocation(location);
            if (handleResult) {
              return account;
            }
          }
          // no available internet accounts
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        return null;
      }
    };
  }).views(function (self) {
    return {
      get jbrowse() {
        return self.config;
      }
    };
  });
  return {
    model: rootModel,
    pluginManager: pluginManager
  };
}